import { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { AssignmentType, DemoSource } from 'models/enum';
import { CaseStudy, SimulationEhr } from 'models/ui';
import { RouteParams, RoutePath } from 'constants/app.constant';
import { appHelper } from 'helpers';
import { caseStudyService, simulationService } from 'services';
import { instructorActions } from 'redux/ducks/instructor';
import { studentActions } from 'redux/ducks/student';
import AssignmentPreviewContent from 'components/common/assignment-preview-content/AssignmentPreviewContent';
import { ELSButton, ELSFlex, ELSFlexItem } from 'components/common/els';

interface AssignmentPreviewProp {
  demoContent: CaseStudy | SimulationEhr;
  onBack: Function;
  setCaseStudyDemo: Function;
  setAssignmentDemoSource: Function;
  setAssignmentDemoUrl: Function;
  setSimulationEhrDemo: Function;
  assignmentType: string;
}

export class AssignmentPreview extends Component<AssignmentPreviewProp & RouteComponentProps> {
  handleSwitchToStudentView = () => {
    const { history, demoContent, setCaseStudyDemo, setSimulationEhrDemo, assignmentType } = this.props;
    if(assignmentType === AssignmentType.CASE_STUDY) {
      setCaseStudyDemo(demoContent);
      return appHelper.useLoader(
      caseStudyService.prepareDemoCaseStudy({ caseStudyId: demoContent.id }).then(({ data }) => {
        const { demoAssessmentId } = data;
        const path = RoutePath.student.caseStudyLanding.replace(RouteParams.ASSESSMENT_ID, demoAssessmentId);
        this.props.setAssignmentDemoSource(DemoSource.ASSIGNMENT_CREATION_QUICK_VIEW);
        this.props.setAssignmentDemoUrl(this.props.location.pathname);
        history.push(path);
      })
    );
    } else {
      setSimulationEhrDemo(demoContent);
      return appHelper.useLoader(
      simulationService.prepareDemoSimulationEhr({ simulationEhrId: demoContent.id }).then(({ data }) => {
        const { demoAssessmentId } = data;
        const path = RoutePath.student.simulationEhrLanding.replace(RouteParams.ASSESSMENT_ID, demoAssessmentId);
        this.props.setAssignmentDemoSource(DemoSource.ASSIGNMENT_CREATION_QUICK_VIEW);
        this.props.setAssignmentDemoUrl(this.props.location.pathname);
        history.push(path);
      })
    );
    }
  };

  render() {
    const { onBack, demoContent, assignmentType } = this.props;

    return (
      <div>
        <ELSFlex className="u-els-margin-top u-els-margin-bottom-2x" middle spaceBetween>
          <ELSFlexItem>
            <ELSButton text="Back" type="secondary" onClick={onBack} />
          </ELSFlexItem>
          <ELSFlexItem>
            <ELSButton text="Switch to Student View" type="primary" onClick={this.handleSwitchToStudentView} />
          </ELSFlexItem>
        </ELSFlex>

        <AssignmentPreviewContent demoContent={demoContent} assignmentType={assignmentType} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setCaseStudyDemo: (data) => dispatch(instructorActions.setCaseStudyDemo(data)),
  setSimulationEhrDemo: (data) => dispatch(instructorActions.setSimulationEhrDemo(data)),
  setAssignmentDemoSource: (source: string) => dispatch(studentActions.setAssignmentDemoSource(source)),
  setAssignmentDemoUrl: (url: string) => dispatch(studentActions.setAssignmentDemoUrl(url))
});

export default compose(withRouter, connect(null, mapDispatchToProps))(AssignmentPreview);
